import React, { FC } from 'react';
import { LoginComponent } from '../../components/Login/Login';
import { APP_ROUTES } from '../../global/AppRouter/routes';

export const AdminDashboard: FC = () => {
  return <LoginComponent redirectionPath={`${APP_ROUTES.DASHBOARD_MENU}`} topNavName="Admin dashboard" />;
};
